import styled from 'styled-components';
import { colors, fonts } from '../../styles/theme';

type RequiredFieldsProps = {
  margin?: string;
}

export const BannerWrapper = styled.div`
  width: 100%;
`;

export const RequiredFieldsError = styled.div<RequiredFieldsProps>`
  color: ${colors.color14};
  width: 100%;
  border: 2px solid ${colors.color14};
  padding: 1rem;
  margin: ${({ margin }) => margin || '0 0 2.5rem'};
  background-color: ${colors.color4};
`;

export const RequiredTextStyled = styled.span`
  ${fonts.lato.H16};
  padding-left: 1rem;
`;
